import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { getFileShares, createFileShare, revokeFileShare } from '../services/file-api'

export const useFileShares = (fileId: string) =>
	useQuery({
		queryKey: ['file-shares', fileId],
		queryFn: () => getFileShares(fileId),
		enabled: !!fileId,
	})

export const useCreateFileShare = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async ({
			fileId,
			data,
		}: {
			fileId: string
			data: { userId: string; permission: string; expiresAt?: string }
		}) => {
			return createFileShare(fileId, data)
		},
		onSuccess: (_data, variables) => {
			void qc.invalidateQueries({ queryKey: ['file-shares', variables.fileId] })
		},
	})
}

export const useRevokeFileShare = () => {
	const qc = useQueryClient()
	return useMutation({
		mutationFn: async ({ fileId, shareId }: { fileId: string; shareId: string }) => {
			await revokeFileShare(fileId, shareId)
		},
		onSuccess: (_data, variables) => {
			void qc.invalidateQueries({ queryKey: ['file-shares', variables.fileId] })
		},
	})
}
